import { showToast } from '../utils/toast';

const useToast = () => ({
  error: (message) => showToast('error', message),
  warn: (message) => showToast('warning', message),
  success: (message) => showToast('success', message),
  info: (message) => showToast('info', message)
});

export default useToast;
